// ** React Imports
import React, { useEffect, useState } from "react";

// ** Third Party Imports
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

// ** Store Imports
import { getId, updateId } from "../../store/reducers/task/taskActions";

const Settings = () => {
    // ** States
    const [id, setId] = useState("");
    const [loading, setLoading] = useState(false);

    // ** Hooks
    const dispatch = useDispatch();
    const intl = useIntl();

    useEffect(() => {
        dispatch(getId()).then(response => setId(response.data.data)).catch(() => null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = event => {
        event.preventDefault();
        setLoading(true);
        dispatch(updateId({ id }))
            .then(() => toast.success(intl.formatMessage({ id: "settings.success.update_next_task_id" })))
            .catch(() => null)
            .finally(() => setLoading(false));
    }

    return (
        <div className="box is-desktop">
            <h4 className="title has-text-primary is-4">
                <FormattedMessage id="menu.settings"/>
            </h4>
            <form onSubmit={onSubmit}>
                <div className="columns is-desktop">
                    <div className="column">
                        <div className="field">
                            <label className="label"><FormattedMessage id="settings.next_task_id"/></label>
                            <div className="control">
                                <input
                                    className="input"
                                    disabled={!id || loading}
                                    onChange={event => setId(event.target.value)}
                                    type="number"
                                    value={id}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="is-flex column is-3">
                        <button className={`button is-info${loading ? " is-loading" : ""}`} disabled={!id} type="submit">
                            <FormattedMessage id="general.save"/>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Settings;
